import { docReady } from '../utils/docReady';
import { isEnabled, onEnabled, getHandles } from '../utils/cartHistoryUtil';
const GRID_ID = 'collection-products-grid';
const MAIN_ID = 'collection-main';
const ADD_AGAIN_BADGE_CLASS = 'add-again-tag';
const extractHandle = (tile) => {
    const link = tile.querySelector('a[href*="/products/"]');
    const href = link && link.getAttribute('href');
    if (!href)
        return null;
    const match = href.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
};
const applyBadge = (tile) => {
    if (tile.querySelector(`.${ADD_AGAIN_BADGE_CLASS}`)) {
        return;
    }
    // Add Again takes precedence over the product_tag/visible_tag metafield badges - same
    // rule the old React ProductTile used.
    tile.querySelectorAll('.collection__product-tag').forEach((tag) => {
        tag.style.display = 'none';
    });
    const imageLink = tile.querySelector('.collection__product-image');
    if (!imageLink)
        return;
    const strings = (window.theme || {}).strings || {};
    const badge = document.createElement('div');
    badge.className = `collection__product-tag ${ADD_AGAIN_BADGE_CLASS}`;
    badge.innerHTML = `<span>${strings.add_again || 'Add Again'}</span>`;
    imageLink.appendChild(badge);
};
let isReordering = false;
const reorderTiles = (grid, matchedTiles) => {
    if (matchedTiles.length === 0)
        return;
    const currentFront = Array.from(grid.children).slice(0, matchedTiles.length);
    const alreadyInOrder = matchedTiles.every((tile, index) => currentFront[index] === tile);
    if (alreadyInOrder)
        return;
    isReordering = true;
    [...matchedTiles].reverse().forEach((tile) => {
        grid.insertBefore(tile, grid.firstElementChild);
    });
    // Deferred as a microtask so it runs *after* the MutationObserver callback our own
    // insertBefore calls above just queued (queued microtasks run in order) - the observer's
    // callback needs to still see isReordering === true when it fires.
    Promise.resolve().then(() => {
        isReordering = false;
    });
};
const applyUsualPicks = () => {
    if (!isEnabled())
        return;
    const grid = document.getElementById(GRID_ID);
    if (!grid)
        return;
    const handles = getHandles();
    if (handles.length === 0)
        return;
    const tiles = Array.from(grid.querySelectorAll(':scope > .collection__product'));
    const matchedTiles = [];
    handles.forEach((handle) => {
        const tile = tiles.find((candidate) => matchedTiles.indexOf(candidate) === -1 && extractHandle(candidate) === handle);
        if (tile) {
            matchedTiles.push(tile);
        }
    });
    if (matchedTiles.length === 0)
        return;
    matchedTiles.forEach(applyBadge);
    reorderTiles(grid, matchedTiles);
};
let observerStarted = false;
const startObserver = () => {
    if (observerStarted || typeof MutationObserver === 'undefined')
        return;
    const main = document.getElementById(MAIN_ID);
    if (!main)
        return;
    observerStarted = true;
    // main-collection.liquid's own filter/sort script swaps main.innerHTML wholesale, which
    // recreates every tile - re-run once that settles.
    const observer = new MutationObserver(() => {
        if (isReordering)
            return;
        applyUsualPicks();
    });
    observer.observe(main, { childList: true, subtree: true });
};
docReady(() => {
    onEnabled(() => {
        applyUsualPicks();
        startObserver();
        window.addEventListener('usual-picks-history-updated', applyUsualPicks);
    });
});
